import { updateUserLogic } from './updateUserLogic';
import { trackBookingLogic } from './trackBookingLogic';

export const logic = [trackBookingLogic, updateUserLogic];
